import { WorkspaceSinchSettingsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/settings/actions/sinch')({
  component: WorkspaceSinchSettingsRoute,
});
